import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const scrapeSuccessful = (provider: String) => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:${provider}:successful`, 
        category: settings.categoryName 
    });
};

export default scrapeSuccessful;